exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".embedControls__embedControls--1st-l,.embedControls__label--3d-ov,.embedControls__textarea--48GSi{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Source Sans Pro,sans-serif}.embedControls__embedControls--1st-l{width:300px;width:18.75rem}.embedControls__embedControls--1st-l li:not(:last-child){margin-bottom:.5em}.embedControls__label--3d-ov{color:#218291;font-family:Source Sans Pro,sans-serif;font-size:12px;font-size:.75rem;font-weight:600;letter-spacing:1.008px;letter-spacing:.063rem;line-height:1.25;text-transform:uppercase;margin-bottom:0}.embedControls__textarea--48GSi{width:100%}", ""]);

// exports
exports.locals = {
	"embedControls": "embedControls__embedControls--1st-l",
	"label": "embedControls__label--3d-ov",
	"textarea": "embedControls__textarea--48GSi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/var/www/prb-datafinder/client/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./app/components/embedControls/embedControls.scss
// module id = 647
// module chunks = 0